import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const LOGOS = {
  vnf_rf:      "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/vwx7ismp_VOIES%20NAVIGABLES%20DE%20FRANCE%20.png",
  prefet_occ:  "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/tvfubbxt_Logo%20PREF_region_Occitanie_RVB.webp",
  unesco30:    "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/y53fq32c_OIP.jpg",
  vinovalie:   "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/wctv09cj_vinovalie.jpg",
  lumeo:       "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/6i8n5322_lumeo%20concept.jpg",
  castelnau:   "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/rf3uctbk_Logo_Castelnau_reseaux_rvb-1024x518.webp",
  bvdn:        "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/81y2bfib_new-bvdn-logo-300x194.png",
  atelier:     "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/ouppqnq7_Logo-ADI.png",
  jimenez:     "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/yrsl884e_jimenez%20logo.jpg",
  arteurs:     "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/pm6o2yg0_ARTEURS_Noir.webp",
  capech:      "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/itbqucu4_logo-Capech-2015-2000-1091-.png",
  reeso:       "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/1wyo58wh_logo-club-reeso-fond-transparent.png",
  chako:       "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/rpct9kkv_Logo%20Chako.jpg",
};

const institutionnels = [
  { name: "Les Arteurs", tag: "Co-organisateur · Association fondatrice du Fil", logo: LOGOS.arteurs, url: "https://les-arteurs.org", cls: "bg-white p-8" },
  { name: "VNF · République Française", tag: "Partenaire Officiel · Haut-patronage", logo: LOGOS.vnf_rf, url: "https://www.vnf.fr", cls: "bg-white p-8" },
  { name: "Préfecture de la Région Occitanie", tag: "Soutien institutionnel · SGAR Occitanie", logo: LOGOS.prefet_occ, url: "https://www.prefectures-regions.gouv.fr/occitanie", cls: "bg-white p-8" },
  { name: "Mairie de Castelnau d'Estrétefonds", tag: "Partenaire Institutionnel · Ville d'ancrage", logo: LOGOS.castelnau, url: "https://www.castelnau-estretefonds.fr", cls: "bg-white p-8" },
];

// Partenaires réellement engagés (financier ou technique) sur 2026 —
// utilisés pour le bandeau défilant en tête de /partenaires.
export const ENGAGED_2026 = [
  { name: "Les Arteurs",              logo: LOGOS.arteurs,   url: "https://les-arteurs.org" },
  { name: "VNF",                      logo: LOGOS.vnf_rf,    url: "https://www.vnf.fr" },
  { name: "Préfecture Occitanie",     logo: LOGOS.prefet_occ,url: "https://www.prefectures-regions.gouv.fr/occitanie" },
  { name: "Castelnau d'Estrétefonds", logo: LOGOS.castelnau, url: "https://www.castelnau-estretefonds.fr" },
  { name: "Vinovalie",                logo: LOGOS.vinovalie, url: "https://www.vinovalie.com" },
  { name: "Luméo Concept",            logo: LOGOS.lumeo,     url: "https://www.lumeo-concept.fr" },
  { name: "JIMENEZ",                  logo: LOGOS.jimenez,   url: "https://www.jimenez-groupe.com" },
  { name: "REESO",                    logo: LOGOS.reeso,     url: "https://www.club-reeso.fr" },
  { name: "Chako Design",             logo: LOGOS.chako,     url: "https://www.arteurs.com" },
  { name: "BVDN",                     logo: LOGOS.bvdn,      url: "https://boulevarddunil.com" },
  { name: "Atelier de l'Impression",  logo: LOGOS.atelier,   url: "https://www.atelierdelimpression.com" },
  { name: "Le Capech à la Côte",      logo: LOGOS.capech,    url: "https://www.lecapech.com" },
];

const sponsors = [
  { name: "Vinovalie", tag: "Les vignerons d'Ovalie · Sud-Ouest France", logo: LOGOS.vinovalie, url: "https://www.vinovalie.com" },
  { name: "Luméo Concept", tag: "Partenaire lumière & scénographie", logo: LOGOS.lumeo, url: "https://www.lumeo-concept.fr" },
  { name: "Transports JIMENEZ", tag: "Transport & Location · Sponsor", logo: LOGOS.jimenez, url: "https://www.jimenez-groupe.com", cls: "bg-white p-6" },
  { name: "REESO", tag: "Réseau d'Entreprises · Eurocentre Sud-Ouest", logo: LOGOS.reeso, url: "https://www.club-reeso.fr", cls: "bg-white p-6" },
  { name: "Chako Design", tag: "Sponsor · Design", logo: LOGOS.chako, url: "https://www.arteurs.com", cls: "bg-black p-6" },
];

const techniques = [
  { name: "Boulevard de Nil · BVDN", tag: "Partenaire Technique", logo: LOGOS.bvdn, url: "https://boulevarddunil.com", cls: "bg-white p-8" },
  { name: "L'Atelier de l'Impression", tag: "Impression · Parce que la première est la bonne", logo: LOGOS.atelier, url: "https://www.atelierdelimpression.com", cls: "bg-white p-8" },
  { name: "Le Capech à la Côte", tag: "Soutien · Restaurant · Escale", logo: LOGOS.capech, url: "https://www.lecapech.com", cls: "bg-white p-6" },
];

function LogoTile({ p, i, big = false }) {
  const inner = (
    <>
      {p.logo ? (
        <div className={`flex-1 flex items-center justify-center ${p.cls || "p-8 bg-white"}`}>
          <img src={p.logo} alt={p.name} className="max-h-32 max-w-[80%] object-contain" loading="lazy" />
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="font-serif text-2xl md:text-3xl leading-tight tracking-tight text-center">{p.name}</div>
        </div>
      )}
      <div className="border-t border-fg/15 px-5 py-4 bg-bg group-hover:bg-fg group-hover:text-bg transition-colors duration-500">
        <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-cinabre">{p.tag}</div>
        {p.logo && <div className="font-serif text-lg mt-1 leading-tight">{p.name}</div>}
      </div>
    </>
  );

  const baseCls = `relative group bg-bg border border-fg/15 ${big ? "min-h-[240px]" : "min-h-[180px]"} flex flex-col justify-between overflow-hidden`;
  const testid = `partner-${p.name.split(" ")[0].toLowerCase()}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: i * 0.04 }}
      className="h-full"
    >
      {p.url ? (
        <a
          href={p.url}
          target="_blank"
          rel="noreferrer sponsored"
          className={`${baseCls} h-full hover:border-cinabre transition-colors duration-500`}
          data-testid={testid}
          aria-label={`Visiter le site de ${p.name}`}
        >
          {inner}
        </a>
      ) : (
        <div className={`${baseCls} h-full`} data-testid={testid}>
          {inner}
        </div>
      )}
    </motion.div>
  );
}

export default function Partners() {
  const { lang } = useLang();
  const en = lang === "en";
  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12" data-testid="partners">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16">
          <div className="meta-label text-cinabre">§ {en ? "They support Canal'Art 2026" : "Ils soutiennent Canal'Art 2026"}</div>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6 max-w-4xl">
            {en ? <>A rare <em className="italic">alliance</em>: institutions, companies, craftsmen.</> : <>Une <em className="italic">alliance</em> rare : institutions, entreprises, techniciens.</>}
          </h2>
        </div>

        {/* Institutionnels — mise en avant forte */}
        <div className="mb-20">
          <div className="meta-label text-fg/60 mb-6">— {en ? "Institutional partners · High patronage" : "Partenaires institutionnels · Haut-patronage"}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {institutionnels.map((p, i) => <LogoTile key={p.name} p={p} i={i} big />)}
          </div>
        </div>

        {/* Sponsors & Entreprises */}
        <div className="mb-20">
          <div className="meta-label text-fg/60 mb-6">— {en ? "Companies & Sponsors" : "Entreprises & Sponsors"}</div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {sponsors.map((p, i) => <LogoTile key={p.name} p={p} i={i} />)}
          </div>
        </div>

        {/* Techniques */}
        <div>
          <div className="meta-label text-fg/60 mb-6">— {en ? "Technical partners & Supporters" : "Partenaires techniques & Soutiens"}</div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {techniques.map((p, i) => <LogoTile key={p.name} p={p} i={i} />)}
          </div>
        </div>

        <p className="mt-14 font-mono text-[10px] tracking-[0.24em] uppercase text-fg/50 max-w-3xl">
          {en ? "They make Canal'Art 2026 with us." : "Ils font Canal'Art 2026 avec nous."}
        </p>
      </div>
    </section>
  );
}
